const REQUIRED_APPLICATION_LENGTH = 2;
const APPLICATION_ELIGIBILITY_STATUS = 'DE';
const REASON_CODE = 'OTHER';
const CHANGE_TYPE = 'OVERRIDES';
const COVERAGE_YEAR = 2023;
const INPUT_MAX_LENGTH = 4000;
const MMDDYYYY_LENGTH = 8;
const DEFAULT_PERSON_ID = 1;
const PROGRAM_ELIGIBILITY_MODAL_PHASE = 'override';
const ELIGIBILITY_WORKSHEET_DISPLAY_COLUMN = 2;
const COVERAGE_YEAR_DISPLAY_COLUMN = 0;

const SPECIAL_ENROLLMENT_DETAILS_TABLE_HEADER_DATA = [
    {
        id: 'members',
        text: 'cap.application.modal.overrideSpecialEnrollmentDetailsModal.table.header.members',
        isMandatory: false,
    },
    {
        id: 'eventType',
        text: 'cap.application.modal.overrideSpecialEnrollmentDetailsModal.table.header.eventType',
        isMandatory: true,
    },
    {
        id: 'eventDate',
        text: 'cap.application.modal.overrideSpecialEnrollmentDetailsModal.table.header.eventDate',
        isMandatory: true,
    },
];

const OVERRIDE_PROGRAM_ELIGIBILITY_TABLE_HEADER_DATA = [
    {
        id: 'memberName',
        text: 'cap.application.modal.overrideProgramEligibility.tableHeader.memberName',
        renderConditionally: false,
    },
    {
        id: 'exchangeEligibility',
        text: 'cap.application.modal.overrideProgramEligibility.tableHeader.exchangeEligibility',
        renderConditionally: false,
    },
    {
        id: 'aptcEligibility',
        text: 'cap.application.modal.overrideProgramEligibility.tableHeader.aptcEligibility',
        renderConditionally: true,
    },
    {
        id: 'csrEligibility',
        text: 'cap.application.modal.overrideProgramEligibility.tableHeader.csrEligibility',
        renderConditionally: false,
    },
    {
        id: 'medicaidEligibility',
        text: 'cap.application.modal.overrideProgramEligibility.tableHeader.medicaidEligibility',
        renderConditionally: true,
    },
    {
        id: 'chipEligibility',
        text: 'cap.application.modal.overrideProgramEligibility.tableHeader.chipEligibility',
        renderConditionally: true,
    },
];

const EXCHANGE_ELIGIBILITY_OPTIONS = ['Yes', 'No'];
const CSR_ELIGIBILITY_OPTIONS = {
    CS2: { text: 'CS Level 2', value: 'CS2' },
    CS3: { text: 'CS Level 3', value: 'CS3' },
    CS4: { text: 'CS Level 4', value: 'CS4' },
    CS5: { text: 'CS Level 5', value: 'CS5' },
    CS6: { text: 'CS Level 6', value: 'CS6' },
    No: { text: 'No', value: 'No' },
};

export {
    REQUIRED_APPLICATION_LENGTH,
    COVERAGE_YEAR,
    APPLICATION_ELIGIBILITY_STATUS,
    INPUT_MAX_LENGTH,
    SPECIAL_ENROLLMENT_DETAILS_TABLE_HEADER_DATA,
    OVERRIDE_PROGRAM_ELIGIBILITY_TABLE_HEADER_DATA,
    EXCHANGE_ELIGIBILITY_OPTIONS,
    CSR_ELIGIBILITY_OPTIONS,
    MMDDYYYY_LENGTH,
    REASON_CODE,
    CHANGE_TYPE,
    DEFAULT_PERSON_ID,
    PROGRAM_ELIGIBILITY_MODAL_PHASE,
    ELIGIBILITY_WORKSHEET_DISPLAY_COLUMN,
    COVERAGE_YEAR_DISPLAY_COLUMN,
};
